<template>
  <v-container fluid class="px-0">
    <!-- ===== DESKTOP (md and up) ===== -->
    <v-row v-if="display.mdAndUp.value" class="desktop-promos" no-gutters>
      <!-- Card 1 -->
      <v-col cols="12" md="6" class="pr-md-4 pb-4">
        <v-card class="desktop-promo-card" color="blue-lighten-5" elevation="0">
          <div class="desktop-card-inner">
            <!-- Thumb stack (left) -->
            <div class="thumb-stack">
              <v-img
                :src="require('@/assets/new_project_banner_images.png')"
                width="50"
                height="120"
                cover
                class="thumb thumb-1"
              />
              <v-img
                :src="require('@/assets/new_project_banner_images.png')"
                width="50"
                height="120"
                cover
                class="thumb thumb-2"
              />
              <v-img
                :src="require('@/assets/new_project_banner_images.png')"
                width="50"
                height="120"
                cover
                class="thumb thumb-3"
              />
            </div>

            <!-- Copy -->
            <div class="desktop-copy">
              <div class="desktop-title">
                <span class="title-text">Introducing New Projects</span>
              </div>
              <div class="desktop-sub">
                Get access to the latest property developments
              </div>

              <v-btn
                class="cta-desktop"
                color="#b8860b"
                variant="flat"
                append-icon="mdi-arrow-right"
                elevation="0"
                @click="navigateToPropertySearch()"
              >
               <span style="margin-top: -5px;"> Explore Now</span>
              </v-btn>
            </div>
          </div>
        </v-card>
      </v-col>

      <!-- Card 2 -->
      <v-col cols="12" md="6" class="pl-md-4 pb-4">
        <v-card class="desktop-promo-card" color="blue-lighten-5" elevation="0">
          <div class="desktop-card-inner">
            <!-- Copy -->
            <div class="desktop-copy">
              <div class="desktop-title">
                <span class="title-text">Discover Agents and Agencies!</span>
               <v-btn size="x-small" color="#b8860b" style="border-radius: 20px;">New</v-btn>
              </div>
              <div class="desktop-sub">
                Connect with our partners to find your ideal home!
              </div>

              <v-btn
                class="cta-desktop"
                color="#b8860b"
                variant="flat"
                append-icon="mdi-arrow-right"
                elevation="0"
                @click="navigateToPropertySearch()"
              >
               <span style="margin-top: -5px;"> Browse Now</span>
              </v-btn>
            </div>

            <!-- Thumb (right) -->
            <div class="thumb-stack right">
              <v-img
                :src="require('@/assets/agent_search_banner.png')"
                width="120"
                height="120"
                cover
                class="thumb-discover"
              />
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- ===== MOBILE (unchanged) ===== -->
    <v-row v-else class="ma-0">
      <v-col cols="12" class="pa-0">
        <v-window
          v-model="mobileSlide"
          :show-arrows="false"
          class="promo-window hide-arrows"
        >
          <v-window-item :value="0">
            <v-card class="promo-card-mobile" color="blue-lighten-5" elevation="0">
              <div class="promo-mobile">
                <div class="promo-copy">
                  <div class="promo-title">New Projects</div>
                  <div class="promo-sub">
                    Get access to the latest property developments
                  </div>
                </div>
                <v-img
                  :src="require('@/assets/new_project_banner_images.png')"
                  width="76"
                  height="56"
                  class="promo-thumb"
                  cover
                />
              </div>

              <v-btn
                class="cta-mobile"
                variant="flat"
                color="white"
                append-icon="mdi-arrow-right"
                @click="navigateToPropertySearch()"
                block
                style="border-radius: 5px !important"
              >
                Explore Now
              </v-btn>
            </v-card>
          </v-window-item>

          <v-window-item :value="1">
            <v-card class="promo-card-mobile" color="blue-lighten-5" elevation="0">
              <div class="promo-mobile">
                <div class="promo-copy">
                  <v-chip
                    size="x-small"
                    class="mr-3"
                    style="background-color: red; color: white; z-index: 1 !important"
                    >NEW</v-chip
                  >
                  <div class="promo-title d-flex align-center">
                    Discover Agents and Agencies!
                  </div>
                  <div class="promo-sub">
                    Connect with our partners to find your ideal home!
                  </div>
                </div>
                <v-img
                  :src="require('@/assets/agent_search_banner.png')"
                  width="76"
                  height="56"
                  class="promo-thumb"
                  cover
                />
              </div>

              <v-btn
                class="cta-mobile"
                variant="flat"
                color="white"
                append-icon="mdi-arrow-right"
                @click="navigateToPropertySearch()"
                block
              >
                Browse Now
              </v-btn>
            </v-card>
          </v-window-item>
        </v-window>

        <div class="promo-dots">
          <span
            v-for="i in 2"
            :key="i"
            class="dot"
            :class="{ active: mobileSlide === i - 1 }"
            @click="mobileSlide = i - 1"
          />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useDisplay } from "vuetify";

const router = useRouter();
const display = useDisplay();
const mobileSlide = ref(0);

const navigateToPropertySearch = () => {
  router.push({
    name: "PropertySearch",
    params: { categorySlug: "residential" },
    query: { filter: "all-residential", purpose: "all" },
  });
};
</script>

<style scoped>
/* ===================== DESKTOP ONLY ===================== */
@media (min-width: 960px) {
  .desktop-promos {
    margin: 0;
  }

  .desktop-promo-card {
    background: #eef6fd;           /* keep original color */
    border-radius: 12px;
    padding: 20px 24px;
    height: 160px;                 /* fixed height so buttons align */
  }

  .desktop-card-inner {
    position: relative;            /* establish stacking context */
    display: flex;
    align-items: stretch;          /* make children fill height */
    justify-content: space-between;
    height: 100%;
    gap: 16px;
  }

  .desktop-copy {
    position: relative;
    z-index: 2;                    /* ensure text sits above images */
    display: flex;
    flex-direction: column;
    height: 100%;
    min-width: 0;
    gap: 6px;
    flex: 1 1 auto;
  }

  /* single-line headings/subheads (no ellipsis) */
  .desktop-title,
  .desktop-sub {
    white-space: nowrap;
  }

  .desktop-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-family: proxima-nova, ProximaNova, noto, GESS, GE-SS, "Helvetica Neue",
      Helvetica, Arial, sans-serif;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    color: rgba(0, 0, 0, 0.87);
  }

  .desktop-sub {
    font-size: 15px;
    color: #495869;
  }

  .cta-desktop {
    margin-top: auto !important;   /* aligns Explore/Browse baselines */
    align-self: flex-start;
    border-radius: 10px !important;
    text-transform: none !important;
    padding: 10px 16px !important;
    min-width: 160px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
    font-family: proxima-nova, ProximaNova, noto, GESS, GE-SS, "Helvetica Neue",
      Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.87);
    opacity: 0.7 !important;
  }

  .chip-new {
    position: relative;            /* needed for z-index to apply */
    z-index: 3;                    /* above the right thumbnails */
    background-color: darkgoldenrod;
    color: #fff !important;
    font-weight: 700;
    height: 22px !important;
    line-height: 22px;
    padding: 0 8px;
  }

  /* thumbnail stacks */
  .thumb-stack {
    position: relative;
    width: 170px;                  /* space for fanned images */
    height: 120px;
    flex: 0 0 auto;
    z-index: 1;                    /* under the text content */
  }
  .thumb-stack.right {
    order: 2;                      /* on the right for second card */
  }

  .thumb {
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 10px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    margin-left: 20px;
  }

  .thumb-discover{
 position: absolute;
    top: 0;
    left: 0;
    border-radius: 10px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    margin-left: 40px;
  }

  /* fan effect */
  .thumb-1 { transform: rotate(-6deg); }
  .thumb-2 { left: 36px; transform: rotate(0deg); z-index: 2; }
  .thumb-3 { left: 72px; transform: rotate(6deg); z-index: 1; }
}

/* ===================== MOBILE (unchanged) ===================== */
.promo-card-mobile {
  border-radius: 14px;
  padding: 12px;
  margin-bottom: 8px;
  background: #eaf4ff;
  width: 100% !important;
}
.promo-mobile {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
  width: 100% !important;
}
.promo-copy {
  flex: 1;
  min-width: 0;
}
.promo-title {
  font-weight: 700;
  font-size: 14px;
  line-height: 1.15;
  margin-bottom: 4px;
  color: #0a2540;
}
.promo-sub {
  font-size: 12px;
  line-height: 1.25;
  color: #4f5b66;
}
.promo-thumb {
  border-radius: 10px;
  flex-shrink: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  margin-top: 15px !important;
}

.cta-mobile {
  text-transform: none !important;
  font-weight: 600;
  height: 40px;
  justify-content: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  font-family: proxima-nova, ProximaNova, noto, GESS, GE-SS, "Helvetica Neue",
    Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.87);
}

/* dots */
.promo-dots {
  display: flex;
  justify-content: center;
  gap: 6px;
  margin: 4px 0 2px;
}
.dot {
  width: 6px;
  height: 6px;
  background: #c9d3df;
  border-radius: 50%;
  display: inline-block;
  transition: all 0.2s;
}
.dot.active {
  width: 8px;
  height: 8px;
  background: #2d3e50;
}

/* tighten container on very small screens */
@media (max-width: 600px) {
  .v-container {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
</style>
